<div class="menu-panel bg-white flex flex-col w-full">
    <div class="filter-options flex-1 overflow-y-auto px-2 rounded-sm filter-menu-shadow">
        <ng-content />
    </div>
    <div
        class="flex items-center p-3 z-10 filter-menu-shadow bg-white rounded-sm !text-sm gap-2"
        [class]="secondaryActionButton() ? 'justify-between' : 'justify-end'">
        @if (secondaryActionButton()) {
            <app-button
                [disabled]="secondaryActionDisabled()"
                [icon]="secondaryActionButton()!.icon"
                [label]="secondaryActionButton()!.label | transloco"
                [tooltip]="secondaryActionDisabled() ? secondaryActionTooltip() : undefined"
                [type]="secondaryActionButton()!.type ?? ButtonType.SECONDARY"
                (onClick)="secondaryButtonClicked.emit()" />
        }

        <app-button
            iconSize="sm"
            [icon]="['fas', 'check']"
            [label]="'submit' | transloco"
            [type]="ButtonType.PRIMARY"
            (onClick)="submit.emit()" />
    </div>
</div>
